import {SearchTypes} from "../../types/common/search.types";
import apiClient from "../apiClient";
import {ResponseDto} from "../ResponseDto";
import {PageTypes} from "../../types/page.types";
import {ChargeTypes, ExpirationTypes} from "../../types/transaction/transaction.types";

export const getMemberExpiredList = (searchData : SearchTypes) =>
    apiClient.get<ResponseDto<PageTypes>>("/api/front/expiration/getMemberExpirationList",
        {
            params: searchData,
            headers: {'Content-Type': 'application/json'}
        }
    );


export const getMemberExpiredDetail = (expirationCode : string) =>
    apiClient.get<ResponseDto<ExpirationTypes>>("/api/front/expiration/getMemberExpirationDetail",
        {
            params: {expirationCode},
            headers: {'Content-Type': 'application/json'}
        }
    );